import { getAvailableDurationObjectForRTContext } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContextUtils";
import type { RTContextState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import { ECampaignsLoadingState } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignTypes";
import type { RTContextActions } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";
import { ERTContextReducerTypes } from "app/pages/digital-marketing/keywords-campaigns/infra/RTContext.consts";

export const RTContextReducer = (state: RTContextState, action: RTContextActions) => {
    switch (action.type) {
        case ERTContextReducerTypes.InitialCampaignData: {
            return {
                ...state,
            };
        }
        case ERTContextReducerTypes.UpdateCampaignsConfigurations: {
            const { campaignsConfigurations } = action.payload;
            return {
                ...state,
                campaignsConfigurations,
            };
        }
        case ERTContextReducerTypes.UpdateCurrentCampaignConfiguration: {
            const { campaignConfiguration } = action.payload;
            return {
                ...state,
                currentCampaignConfiguration: campaignConfiguration,
                durationObject: campaignConfiguration
                    ? getAvailableDurationObjectForRTContext(campaignConfiguration)
                    : null,
            };
        }
        case ERTContextReducerTypes.UpdateLoadingState: {
            const { loadingState } = action.payload;
            return {
                ...state,
                loadingState,
            };
        }
        case ERTContextReducerTypes.UpdateCampaignsConfigurationsAndLoadingState: {
            const { campaignsConfigurations, loadingState } = action.payload;
            return {
                ...state,
                campaignsConfigurations,
                loadingState,
            };
        }
        case ERTContextReducerTypes.UpdateLoadingLanguagesAndLocationsState: {
            const { isLoading } = action.payload;
            return {
                ...state,
                isLoadingLanguagesAndLocations: isLoading,
            };
        }
        case ERTContextReducerTypes.UpdateDemoCampaigns: {
            const { demoCampaigns } = action.payload;
            return {
                ...state,
                demoCampaigns,
            };
        }
        case ERTContextReducerTypes.UpdateDurationObject: {
            const { durationObject } = action.payload;
            return {
                ...state,
                durationObject,
            };
        }
        case ERTContextReducerTypes.UpdateMyUserConsumptionMetrics: {
            const { myUserConsumptionMetrics } = action.payload;
            return {
                ...state,
                myUserConsumptionMetrics,
            };
        }
        case ERTContextReducerTypes.UpdateLocationsAndLanguagesLists: {
            const { locationsAndLanguagesLists } = action.payload;
            const languagesList = state.locationsAndLanguagesLists.languagesList.length
                ? state.locationsAndLanguagesLists.languagesList
                : locationsAndLanguagesLists.languagesList;
            const locationsList = state.locationsAndLanguagesLists.locationsList.length
                ? state.locationsAndLanguagesLists.locationsList
                : locationsAndLanguagesLists.locationsList;
            return {
                ...state,
                locationsAndLanguagesLists: {
                    languagesList,
                    locationsList,
                },
            };
        }
        case ERTContextReducerTypes.UpdateCampaignsConsumptionMetrics: {
            const { campaignsConsumptionMetrics } = action.payload;
            return {
                ...state,
                campaignsConsumptionMetrics,
            };
        }
        case ERTContextReducerTypes.UpdateParamsOnNavigation: {
            const { campaignConfiguration } = action.payload;
            return {
                ...state,
                currentCampaignConfiguration: campaignConfiguration,
                durationObject: campaignConfiguration
                    ? getAvailableDurationObjectForRTContext(campaignConfiguration)
                    : null,
                loadingState: ECampaignsLoadingState.DONE,
            };
        }
    }
};
